<template>
  <Modal v-if="showModal" @close="$emit('closeModal')">
    <div class="infoReservation">
      <div class="infoReservation__header">
        <span class="title">{{ $t('infoReservation') }}</span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt=""
          @click="$emit('closeModal')"
        />
      </div>
      <div class="infoReservation__body">
        <div v-if="activeReservations.phoneNumber" class="info">
          <p>{{ $t('mobilePhone') }}</p>
          <span>{{ activeReservations.phoneNumber }}</span>
        </div>
        <div v-if="activeReservations.deliveryStatus" class="info">
          <p>{{ $t('deliveryStatus') }}</p>
          <span>{{ $t(activeReservations.deliveryStatus) }}</span>
          <span v-if="activeReservations.deliveryStatus === 'expired'"
            >({{ $t(getDeliveryStatus()) }})</span
          >
        </div>
        <div class="info">
          <p>{{ $t('ssn') }}</p>
          <span>{{ dataSsn || '************' }}</span>
          <Button
            v-if="!dataSsn"
            class="ssn_btn"
            variant="notBordered"
            :title="$t('show')"
            @click="showSsn()"
          />
        </div>
        <div v-if="activeReservations.expiredTime" class="info">
          <p>{{ $t('timeExpired') }}</p>
          <span>{{ dateTime(activeReservations.expiredTime) }}</span>
        </div>
        <div v-if="activeReservations.deliveryId" class="info">
          <p>{{ $t('kolliID') }}</p>
          <span>
            {{
              getIds(
                activeReservations.deliveryId,
                activeReservations.additionalDeliveryIds
              )
            }}
          </span>
        </div>
        <div v-if="activeReservations.fulfillment_order_id" class="info">
          <p>{{ $t('fulfillment_order_id') }}</p>
          <span>{{ activeReservations.fulfillment_order_id }}</span>
        </div>
        <div v-if="activeReservations.is_drug" class="info">
          <p>{{ $t('includesDrug') }}</p>
          <span>{{ getIsDrud(activeReservations.is_drug) }}</span>
        </div>
        <div v-if="activeReservations.lockerId" class="info">
          <p>{{ $t('lockerID') }}</p>
          <span>{{ activeReservations.lockerId.join(', ') }}</span>
        </div>
        <div v-if="activeReservations.order_id" class="info">
          <p>{{ $t('order_id') }}</p>
          <span>{{ activeReservations.order_id }}</span>
        </div>
        <div
          v-if="
            activeReservations.deliveryTime ||
            activeReservations.deliveryUserName
          "
          class="info"
        >
          <p>{{ $t('delivered') }}</p>
          <span
            >{{ activeReservations.deliveryUserName }}
            {{ dateTime(activeReservations.deliveryTime) }}</span
          >
        </div>
        <div
          v-if="
            activeReservations.deleteTime || activeReservations.deleteUserName
          "
          class="info"
        >
          <p>{{ $t('deleted') }}</p>
          <span
            >{{ activeReservations.deleteUserName }}
            {{ dateTime(activeReservations.deleteTime) }}</span
          >
        </div>
        <div
          v-if="
            activeReservations.reservedUserName ||
            activeReservations.reservedTime
          "
          class="info"
        >
          <p>{{ $t('reserved') }}</p>
          <span
            >{{ activeReservations.reservedUserName }}
            {{ dateTime(activeReservations.reservedTime) }}</span
          >
        </div>
        <div
          v-if="
            activeReservations.assignedUserName ||
            activeReservations.assignedTime
          "
          class="info"
        >
          <p>{{ $t('assignedUserName') }}</p>
          <span
            >{{ activeReservations.assignedUserName }}
            {{ dateTime(activeReservations.assignedTime) }}</span
          >
        </div>
        <div
          v-if="
            activeReservations.removedUserName || activeReservations.removedTime
          "
          class="info"
        >
          <p>{{ $t('removed') }}</p>
          <span
            >{{ activeReservations.removedUserName }}
            {{ dateTime(activeReservations.removedTime) }}</span
          >
        </div>
        <div v-if="activeReservations.resendSMSCounter" class="info">
          <p>{{ $t('resendSMSCounter') }}</p>
          <span>{{ activeReservations.resendSMSCounter }}</span>
        </div>
        <div v-if="activeReservations.resendSMSTimestamps" class="info">
          <p>{{ $t('resendSMSTimestamps') }}</p>
          <span>{{ dateTime(isLastTime) }}</span>
        </div>
      </div>
      <div class="infoReservation__buttons">
        <Button
          variant="bordered"
          :title="$t('cancel')"
          @click="$emit('closeModal')"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import moment from 'moment';

@Options({
  name: 'InfoReservation',
  emits: ['getDecodedSsn'],
  props: ['showModal', 'activeReservations', 'showDecodedSsn'],
  computed: {
    isLastTime() {
      return this.activeReservations.resendSMSTimestamps[
        this.activeReservations.resendSMSTimestamps.length - 1
      ].sendTime;
    }
  },
  data() {
    return { dataSsn: '' };
  },
  methods: {
    dateTime(value: string) {
      return moment(value).format('DD.MM.YYYY HH:mm');
    },
    showSsn() {
      this.$emit('getDecodedSsn', this.activeReservations.deliveryId);
    },
    getIds(deliveryId: string, additionalDeliveryIds: Array<string>) {
      if (!additionalDeliveryIds[0] && !additionalDeliveryIds[1]) {
        return deliveryId;
      } else if (additionalDeliveryIds[1] !== '') {
        return deliveryId + ', ' + additionalDeliveryIds.join(', ');
      } else if (additionalDeliveryIds[1] === '') {
        return deliveryId + ', ' + additionalDeliveryIds.join('');
      }
    },
    getDeliveryStatus() {
      if (
        this.activeReservations.deliveryStatus === 'expired' &&
        !this.activeReservations.deliveryTime
      ) {
        return 'reservation';
      } else if (
        this.activeReservations.deliveryStatus === 'expired' &&
        this.activeReservations.deliveryTime
      ) {
        return 'delivery';
      } else {
        return '';
      }
    },
    getIsDrud(value: boolean) {
      if (value) {
        return `${this.$t('yes')}`;
      } else {
        return `${this.$t('no')}`;
      }
    }
  },
  watch: {
    showDecodedSsn() {
      if (this.showDecodedSsn === null) {
        this.dataSsn = this.$t('noSsn');
      } else {
        this.dataSsn = this.showDecodedSsn;
      }
    }
  }
})
export default class InfoReservation extends Vue {}
</script>

<style lang="scss" scoped>
.infoReservation {
  max-width: 700px;
  height: 100%;
  padding: 24px;
  .infoReservation__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 23px;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
      line-height: $fifteenSize;
    }
    img {
      cursor: pointer;
    }
  }
  .infoReservation__body {
    width: 283px;
    height: 275px;
    padding: 16px;
    background-color: $light-grey;
    border: 1px solid $border;
    border-radius: 8px;
    overflow-y: scroll;
    margin-bottom: 23px;

    .info {
      margin-bottom: 25px;
      background-color: $light-grey;
      p {
        color: $label;
        line-height: 14px;
        font-size: $twelveSize;
        background-color: $light-grey;
      }
      span {
        color: $mid-grey;
        line-height: 14px;
        font-size: $fourteenSize;
        background-color: $light-grey;
      }
      .ssn_btn {
        width: 0;
        height: 0;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
